var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitlesByIsbn } from "../api/titleService";
import { VOLUME_STATUS, expandEnforcementTypes, } from "../utils/volumeConstants";
import { usePageSize } from "./usePageSize";
import { isCountCapped } from "../utils/exactCount";
import { useExactTotalCount } from "./useExactTotalCount";
import { DEFAULT_TITLE_SORT } from "../utils/titleSort";
var VOLUME_TO_DEPOSIT_STATUSES = Object.entries(VOLUME_STATUS).reduce(function (acc, _a) {
    var _b;
    var depositStatus = _a[0], volumeStatus = _a[1];
    ((_b = acc[volumeStatus]) !== null && _b !== void 0 ? _b : (acc[volumeStatus] = [])).push(depositStatus);
    return acc;
}, {});
var expandStatuses = function (volumeStatuses) {
    return volumeStatuses.flatMap(function (vs) { var _a; return (_a = VOLUME_TO_DEPOSIT_STATUSES[vs]) !== null && _a !== void 0 ? _a : []; });
};
var buildParams = function (filters) {
    var name = filters.name.trim();
    var isbn = filters.isbn.trim();
    var publisherId = filters.publisherId.trim();
    var days = filters.days.trim();
    var depositStatuses = expandStatuses(filters.statuses);
    var enforcementTypes = expandEnforcementTypes(filters.statuses);
    var partiallyReceived = filters.statuses.includes("partial");
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (name && { title: name })), (isbn && { isbn: isbn })), (publisherId && { publisherId: publisherId })), (days && { minDaysSinceUrgence: days })), (depositStatuses.length > 0 && { statuses: depositStatuses })), (enforcementTypes.length > 0 && { enforcementTypes: enforcementTypes })), (partiallyReceived && { partiallyReceived: true })), (filters.provisional && { provisional: true })), (filters.extraCopies && { extraCopies: true })), (filters.extraCopyReason && {
        extraCopyReason: filters.extraCopyReason,
    })), (filters.agendaState && { agendaState: filters.agendaState }));
};
export var useTitlesIsbnData = function (appliedFilters, withIsbn, sort) {
    var _a;
    if (sort === void 0) { sort = DEFAULT_TITLE_SORT; }
    var kyInstance = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = usePageSize(), pageSize = _c.pageSize, setPageSize = _c.setPageSize;
    var _d = useState(0), totalRecords = _d[0], setTotalRecords = _d[1];
    useEffect(function () {
        setPageOffset(0);
    }, [appliedFilters, sort]);
    var _e = useQuery([
        withIsbn ? "titlesWithIsbn" : "titlesWithoutIsbn",
        appliedFilters,
        sort,
        pageOffset,
        pageSize,
    ], function () {
        var searchParams = buildParams(appliedFilters);
        return fetchTitlesByIsbn(kyInstance, withIsbn, __assign(__assign({}, searchParams), { sortBy: sort.sortBy, sortDir: sort.sortDir, offset: pageOffset, limit: pageSize }));
    }, {
        enabled: true,
        keepPreviousData: true,
        onSuccess: function (responseData) {
            var _a;
            setTotalRecords((_a = responseData.totalRecords) !== null && _a !== void 0 ? _a : 0);
        },
    }), data = _e.data, isLoading = _e.isLoading, isFetching = _e.isFetching, isError = _e.isError, error = _e.error, refetch = _e.refetch;
    var totalRecordsExact = data === null || data === void 0 ? void 0 : data.totalRecordsExact;
    var exactTotalRecords = useExactTotalCount({
        queryKey: [
            withIsbn ? "titlesWithIsbn" : "titlesWithoutIsbn",
            appliedFilters,
        ],
        fetchTotalRecords: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchTitlesByIsbn(kyInstance, withIsbn, __assign(__assign({}, buildParams(appliedFilters)), { countOnly: true }))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.totalRecords];
                }
            });
        }); },
        totalRecordsExact: totalRecordsExact,
    });
    var fetchMoreData = useCallback(function (offset) { return setPageOffset(offset); }, []);
    var changePageSize = useCallback(function (size) {
        setPageSize(size);
        setPageOffset(0);
    }, [setPageSize, setPageOffset]);
    return {
        titlesData: (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [],
        totalRecords: exactTotalRecords !== null && exactTotalRecords !== void 0 ? exactTotalRecords : totalRecords,
        exactTotalRecords: exactTotalRecords,
        isCountCapped: isCountCapped(totalRecordsExact, exactTotalRecords),
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        error: error,
        refetch: refetch,
        fetchMoreData: fetchMoreData,
        pageOffset: pageOffset,
        pageSize: pageSize,
        changePageSize: changePageSize,
    };
};
